module.exports = {"create_energetic_inform":"Crear Informe Energético","date_range":"Rango de fechas","create":"Crear","energetic_inform":"Informe Energético"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/EnergeticInform.json
// module id = 600
// module chunks = 1